import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
// import { Base64 } from 'js-base64';

@Injectable({
  providedIn: 'root'
})
export class  FleetService {
  apiUrl:any=environment.url.BASE_URL
  url:any = environment.url.authUrl
  apiUrlV3 = environment.url.apiUrlv3
  authUrl = environment.url.authUrl
  apiUrlNew:any = environment.url.apiUpdateUrl
  profileDetails = new Subject()
  constructor(private http:HttpClient) { }

  getAllProvider() {
    return this.http.get(this.url + 'providers')
  }

  getWordFileContent(filePath: string): Observable<string> {
    return this.http.get(filePath, { responseType: 'text' });
  }

  addFleetApi(body) {
    return this.http.post(this.apiUrl + 'fleet',body)
  }
  getAllFleetList(searchData?:any) {
    if(searchData) {
      let param = new HttpParams().set('request',searchData);
      return this.http.get(this.apiUrl + 'fleet',{params:param})
    } else {
      return this.http.get(this.apiUrl + 'fleet')
    } 
  }

  getAllFleetLists(consumerName) {
    return this.http.get(this.apiUrl + `fleet?consumer=${consumerName}`);
  }


  getFleetOwner(id){
    return this.http.get(this.apiUrl + `fleet/owner/${id}`)
  }

  addConsentForm(id,filePdf,pId) {
    let formdata = new FormData()
    formdata.append('fleetId',id)
    formdata.append('file',filePdf)
    formdata.append('providerId',pId)
    // formdata.append('file',new File([filePdf],'consentAgreement'))
    return this.http.post(this.apiUrl + 'fleet/consent',formdata)
  }

  addFleetUser(body) {
    return this.http.post(this.apiUrl + 'user',body)
  }

  getFleetList() {
    return this.http.get(this.apiUrl + 'fleet/owner/')
  }

  fleetDetailById(id) {
    return this.http.get(this.apiUrl + 'fleet/'+id)
  }

  rejetConsent(id,pId) {
    let formdata = new FormData()
    formdata.append('fleetId',id)
    formdata.append('providerId',pId)
    return this.http.post(this.apiUrl + 'fleet/consent/reject',formdata)
  }

  updateFleet(id,data) {
    return this.http.put(this.apiUrl + `fleet/${id}`,data)
  }

  downloadConsentPdf(url:any) { 
    let param = new HttpParams().set('pdfUrl',url)
    return this.http.get(this.apiUrl + 'fleet/preSigned/',{params:param,responseType:'text'})
    //     const headers = new HttpHeaders({
    //   'Content-Type': 'application/json' // Set your desired headers
    // });

    // // Use params with HttpHeaders
    // const options = { headers: headers, responseType: 'blob' as 'json', params: yourParams };

  }

  blobPdf(url) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/pdf' // Set appropriate content type if known
    });

    return this.http.get(url, {
      headers: headers,
      responseType: 'blob'
    });
  }

  getImage() {
    return this.http.get(this.apiUrl + 'fleet/consumer/logo')
  }

  uploadImage(img) {
    let formdata = new FormData()
    formdata.append('file',img)
    return this.http.post(this.apiUrl + 'fleet/consumer/logo',formdata)
  }

  getProfile() {
    return this.http.get(this.apiUrl + 'fleet/profiling-default-value')
  }

  updateProfile(fleetId,body,gid?) {
    let param = new HttpParams()
    if(gid) {
      param = param.append('groupId',gid)
    }
    return this.http.put(this.apiUrl + 'fleet/profiling/'+fleetId,body,{params:param})
  }

  addFord(id,pId) {
      let formdata = new FormData()
      formdata.append('fleetId',id)
      formdata.append('providerId',pId)
      return this.http.post(this.apiUrl + 'fleet/consent',formdata)
    
  }

  setProfileDetails(data) {
    this.profileDetails.next(data)
  }

  sendMail(fleetId) {
    return this.http.get(this.apiUrl + `fleet/send-notification-mail-owner/${fleetId}`)
  }

  sendInvite(fleetId) {
    // let param = new HttpParams().set('fleetId',fleetId)
    return this.http.get(this.apiUrl + `fleet/send-email-template/${fleetId}`)
  }

  updateFleetProfile(id,body) {
    return this.http.put(this.apiUrl + `fleet/update/${id}`,body)
  }

  getAllVehicles() {
    return this.http.get(this.authUrl + 'vehicle/enrollment/manage-vehicle');
  }

  getAllProvidersAdmin1(consumer?) {
    return this.http.get(this.authUrl + 'providers')
}

bulkvinUploads(data) {
  return this.http.post(this.apiUrlV3 + 'bulk-eligibility-check', data)
}



  getAllVehiclesForUnEnroll(obj) {
    console.log(obj);
    let param = new HttpParams()
      .set("enrollmentState", 'ACTIVE')
      
    if (obj.provider) {
      param = param.append('provider', obj.provider)
    }
    if (obj.consumer) {
      param =param.append('consumer', obj.consumer)
    }
    if (obj.vin) {
      param =param.append('vin', obj.vin)
    }
    return this.http.get(this.authUrl + 'manage-vehicle/manage-vehicle-getall', { params: param });


  }


  getAllDataVehicle() {
    const param = new HttpParams()
      .set('page', '0')
      .set('size', '30')
    return this.http.get(this.authUrl + 'enrollments', { params: param })
  }

  bulkUnEnrollVin(data) {
    const options = {
      body: data
    };
    return this.http.delete(this.authUrl + `enrollments/bulk-un-enroll`, options)
  }

  downloadSample(consumerName) {
    return this.http.get(this.authUrl + `enrollments/bulk/template?consumer=${consumerName}`, { responseType: 'blob' });
  }

  getAllPackagesData() {
    return this.http.get(this.authUrl + 'cx-packages')
  }
  getPackagesDataById(id) {
    return this.http.get(this.authUrl + 'consumers/' + id)
  }
  getStates(id) {
    return this.http.get(this.authUrl + `countries/state?countryId=${id}`)
  }

  getCountries() {
    return this.http.get(this.authUrl + 'countries')
  }

  addFleetEnrollment(data) {
    return this.http.post(this.authUrl + 'vehicle/enroll', data)
  }

  getAllConsumers() {
    return this.http.get(this.authUrl + 'consumers')
  }



  updateEnrollment(obj, id) {
    return this.http.put(this.authUrl + `vehicles/enrollment/${id}`, obj);
  }

  fleetSummarys(consumer) {
    if (consumer) {
      return this.http.get(this.authUrl + `fleets?consumer=${consumer}`)
    } else {
      return this.http.get(this.authUrl + 'fleets')
    }

  }

  unEnroll(id) {
    let params = new HttpParams().set("vin", id);
    return this.http.post(this.authUrl + `vins/un-enroll`, params)
  }

  deleteEnrollVIN(vin,reasonType,otherReason?) {
    let param = new HttpParams()
    if (reasonType) {
      param = param.append('reason', reasonType);
    }

    if (reasonType == 'Others') {
      param = param.append('ifOthers', otherReason);
    }
    return this.http.delete(this.authUrl + 'enrollments/' + vin,{params:param})
  }

  activateEnrollVIN(vin, data) {
    // let param = new HttpParams()
    // .set('vin',vin)
    // .set('validTill',date)
    return this.http.patch(this.authUrl + 'enrollments/' + vin, data)
  }

  vehicleListSummary(fleetId?,consumer?) {
    let param = new HttpParams()
    if(fleetId) {
      param = param.append('fleetId', fleetId);
    }
    if(consumer) {
      param = param.append('consumer',consumer)
    }
    return this.http.get(this.authUrl + 'fleets/vins',{params:param})
  }

  deactivateEnrollVIN(vin) {
    let body: any = {
      action: 'DEACTIVATE'
    }
    return this.http.patch(this.authUrl + 'enrollments/' + vin, body)
  }

  bulkUpload(data) {
    return this.http.post(this.authUrl + 'enrollments/bulk', data)
  }

  addEnrollmentFleet(data) {
    return this.http.post(this.authUrl + 'enrollments', data)
  }

  addEnrollmentinsurance(data) {
    return this.http.post(this.authUrl + 'enrollments', data)
  }

  getAllConsumer() {
    return this.http.get(this.authUrl + 'consumers');
  }

  getCountry() {
    return this.http.get(this.authUrl + 'countries');
  }

  getAllProvidersAdmin(consumer?) {
    if (consumer) {
      return this.http.get(this.authUrl + `providers?consumer=${consumer}`)
    } else {
      return this.http.get(this.authUrl + 'providers')
    }
  }

  getState(id) {
    return this.http.get(this.authUrl + `countries/state?countryId=${id}`)
  }

  getReported(id) {
    return this.http.get(this.authUrl + `eligibility-reports/${id}/report-items`)
  }


  vinEligibiliyt(provider, vin) {
    return this.http.get(this.authUrl + `vehicle/check-eligibility?provider=${provider}`, vin)
  }

  getBulk() {
    return this.http.get(this.authUrl + 'eligibility-reports')
  }

  bulkvinUpload(data) {
    return this.http.post(this.authUrl + 'eligibility-reports/bulk', data)
  }


  addverification(data) {
    return this.http.post(this.authUrl + 'eligibility-reports', data)
  }

  getManageList(page?, size?, vin?, consumer?, oem?, sortDate?, sortStatus?,fleetId?,vehicle?,reason?,inactiveForDays?,status?,action?,vins?,packageData?,vinSearch?,actionOn?,startDate?,endDate?) {
    let param = new HttpParams().set('page', page - 1).set('size', size)
    if (vin && !vinSearch) {
      param = param.append('vin', vin);
    }
    if (vinSearch) {
      param = param.append('vin', vinSearch);
    }
    if (consumer) {
      param = param.append('consumer', consumer);
    }
    if (oem) {
      param = param.append('provider', oem);
    }
    if (inactiveForDays) {
      param = param.append('inactiveForDays', inactiveForDays);
    }
    if (sortStatus) {
      param = param.append('sort', 'status,asc');
    }
    if (sortDate) {
      param = param.append('sort', 'creationDate,desc');
    }
    if(fleetId) {
      param = param.append('fleetId', fleetId);

    }
    if(vehicle && !vinSearch) {
      param = param.append('alias', vehicle);

    }
    if(reason) {
      param = param.append('failureReason', reason);

    }
    if(status) {
      param = param.append('enrollmentState', status);

    }
    if(action) {
      param = param.append('errorName', action);
    }
    if(actionOn) {
      param = param.append('actionOn', actionOn);
    }
    if(packageData) {
      param = param.append('packages', packageData);
    }
    if(startDate) {
      param = param.append('creationStartDate', startDate);
    }
    if(endDate) {
      param = param.append('creationEndDate', endDate);
    }
    const body = { vin: vins || [] }; 
    return this.http.post(this.authUrl + 'manage-vehicle/v2/enrollment',body, { params: param })
  }


  getManageLists(consumer: string, fleetId: string,) {
    let apiUrl = this.authUrl + `vindetails/consumer`;

    // Add consumer if it's not 'All'
    if (consumer && consumer !== 'All') {
      apiUrl += `?consumer=${consumer}`;
    }

    // Add fleetId if provided
    if (fleetId) {
      apiUrl += `&fleetId=${fleetId}`;
    }

    return this.http.get(apiUrl);
  }
  getManageListss(fleetId: string,) {
    let apiUrl = this.authUrl + `vindetails/consumer`;

    // Add fleetId if provided
    if (fleetId) {
      apiUrl += `&fleetId=${fleetId}`;
    }

    return this.http.get(apiUrl);
  }

  getManageListViaOem(page, size, fleedId, vin, oem, status, sortDate?) {
    let param = new HttpParams().set('page', page - 1).set('size', size)
    if (vin) {
      param = param.append('vin', vin);
    }
    if (fleedId) {
      param = param.append('fleetid', fleedId);
    }
    if (status) {
      param = param.append('enrollmentState', status);
    }
    if (oem) {
      param = param.append('provider', oem);
    }
    if (sortDate) {
      param = param.append('sort', 'creationDate,desc');
    }
    return this.http.get(this.authUrl + 'manage-vehicle', { params: param })

  }

  getEnrollMentList(fleedId?,filter?) {
    console.log(filter,'ss');
    
    let param = new HttpParams().set('startDate','2022-01-01').set('endDate',new Date().toISOString().split('T')[0])
    let customConsumers = JSON.stringify(sessionStorage.getItem('custom-consumer'));
    let customConsumer = JSON.parse(customConsumers);
    if (customConsumer) {
      param = param.append('consumer', customConsumer);
    }
    if (fleedId) {
      param = param.append('fleetId', fleedId);
    }
  
    if (filter?.status) {
      param = param.append('enrollmentState', filter?.status);
    }
    if (filter?.oem) {
      param = param.append('provider', filter?.oem);
    }
    if (filter?.day) {
      param = param.append('inactiveForDays', filter?.day);
    }
    if(filter?.name) {
      param = param.append('alias', filter?.name);
    }
    if(filter?.reason) {
      param = param.append('failureReason', filter?.reason);
    }
    return this.http.get(this.authUrl + 'manage-vehicle/enrollment-summary-report', { params: param })
  }

  getAnonymization(vin) {
    return this.http.get(this.authUrl+ `vehicle/enrollment/vin/anonymization/${vin}`,{responseType:'text'})
  }
  getDeanonymization(vin) {
    let deanonymizationVIN = {anonymizedvin: vin }
    return this.http.post(this.authUrl+ `vehicle/enrollment/vin/deanonymization`,deanonymizationVIN,{responseType:'text'})
  }


  deleteFleetRecord(id) {
    return this.http.delete(this.apiUrlNew + `fleet/${id}`)
  }

  packageList() {
    return this.http.get(this.apiUrlV3 + 'enroll/package')
  }

  fleetList() {
    return this.http.get(this.apiUrlNew + 'fleet')
  }

  getFleetListConsumer(consumer) {
    if (consumer != 'All') {
      let param = new HttpParams().set('consumer', consumer)
      return this.http.get(this.apiUrlNew + 'fleet', { params: param })
    }
    else {
      return this.http.get(this.apiUrlNew + 'fleet')
    }
  }

  addEnrollment(body) {
    return this.http.post(this.apiUrlV3 + 'vin/enroll',body)
  }

  fleetSummaryDataDateWise(data,fleetId?) {
    let apiUrl = `${this.url}vindetails/vin-status-history`;
    let param = new HttpParams()
    if(data == 'tilldate') {
      param=param.append('startDate','2022-01-01')
      param=param.append('endDate',new Date().toISOString().split('T')[0])
    } else if(data == 'today') {
      param=param.append('timeFrame',data)
    } else if(data == 'yesterday') {
      param=param.append('timeFrame',data)
    } else if(data == 'weekly') {
      
        let nDate = new Date().toISOString(); 
      const toDate = new Date(nDate);
      if (isNaN(toDate.getTime())) {
        return; // Exit if the date is invalid
      }
      const fromDate = new Date(toDate);
      fromDate.setDate(toDate.getDate() - 7);
      const formattedFromDate = fromDate.toLocaleDateString('en-CA'); // 'en-CA' gives YYYY-MM-DD format
      const formattedToDate = toDate.toLocaleDateString('en-CA');
      param=param.append('startDate',encodeURIComponent(formattedFromDate))
      param=param.append('endDate',encodeURIComponent(formattedToDate))
    } else if(data == 'monthly') {
      param=param.append('timeFrame',data)
    } else if(data == 'lastmonth') {
      param=param.append('lastmonth',data)
    } else if(data?.startDate) {
      param=param.append('startDate',data?.startDate)
      param=param.append('endDate',data?.endDate)
    } else {
      param=param.append('startDate','2022-01-01')
      param=param.append('endDate',new Date().toISOString().split('T')[0])
        }
    
  
    // if (consumer) {
    //   param=param.append('consumer',consumer)
    // }
    if (fleetId) {
      param=param.append('fleetId',fleetId)

    }
    return this.http.get(apiUrl,{ params: param });
  }

  sendOEMMail(fleetId,oem) {
    let param = new HttpParams().set('provider',oem)
    return this.http.get(this.apiUrl + `fleet/send-add-oem-notification-mail-owner/${fleetId}`,{params:param})
  }

  updateAlias(vin,alias) {
    const url = `${this.authUrl + 'enrollments/updateVehicle/'}${vin}`;
    const body = { alias };
    return this.http.put(url, body); 
  }

  getAllfailureReason(status?,fleetId?,customConsumer?) {
    // return this.http.get(this.authUrl + 'manage-vehicle/enrollment-failure-reason')
    let param = new HttpParams()
    if(status) {
      param = param.append('status',status)
    }
    if(fleetId) {
      param = param.append('fleetId',fleetId)
    }
    if(customConsumer) {
      param = param.append('consumer',customConsumer)
    }
    return this.http.get(this.authUrl + 'manage-vehicle/failure-reasons',{params:param})
  }

  getAllAction() {
    return this.http.get(this.authUrl + 'manage-vehicle/get-all-action-on')
  }

  
  fleetListNew(consumer: string, fleetId: string,) {
    let apiUrl = this.apiUrlNew + `fleet`;

    // Add consumer if it's not 'All'
    if (consumer && consumer !== 'All') {
      apiUrl += `?consumer=${consumer}`;
    }

    // Add fleetId if provided
    if (fleetId) {
      apiUrl += `&fleetId=${fleetId}`;
    }

    return this.http.get(apiUrl);
  }

  fleetListNewData(fleetId: string,) {
    let apiUrl = this.apiUrlNew + `fleet`;

    // Add fleetId if provided
    if (fleetId) {
      apiUrl += `&fleetId=${fleetId}`;
    }

    return this.http.get(apiUrl);
  }


  reportGenerated(fleetId: string, vin: string, startDate: string) {
    const apiUrl = this.url + `clickhouse/get-collision-report`;
    const requestBody = {
      fleetId,
      vin,
      startDate
    };
    return this.http.post(apiUrl, requestBody);
  }

  acceptConsentAzuga(id,filePdf,pId) {
    let formdata = new FormData()
    formdata.append('fleetId',id)
    formdata.append('file',filePdf)
    formdata.append('providerId',pId)
    // formdata.append('file',new File([filePdf],'consentAgreement'))
    return this.http.post(this.url + 'cms/fleet/tsp/consent',formdata)
  }

  // acceptConsentAzuga(id: string, pId: string) {
  //   const urlWithParams = `${this.url}cms/fleet/tsp/consent?fleetId=${id}&providerId=${pId}`;
    
  //   let formdata = new FormData();
    
  //   return this.http.post(urlWithParams, formdata);
  // }

  
 rejectConsentAzuga(id: string, pId: string) {
    const urlWithParams = `${this.url}cms/fleet/tsp/consent/reject?fleetId=${id}&providerId=${pId}`;
    let formdata = new FormData();
    return this.http.post(urlWithParams, formdata);
  }

  postFaq(categories:string,subcategories:string,question: string, answer: string): Observable<any> {
    const body = { 
      faq_category_id: categories,
      faq_sub_category_id:subcategories,
      question, 
      answer };
    return this.http.post<any>(`${this.url}faq`, body);
  }

  getFaqQuestionAnswer() {
    return this.http.get(this.url + 'faq')
  }

  deleteFaq(faqId: number) {
    return this.http.delete(this.url+ `faq/delete/${faqId}`);
  }

    // Update FAQ
    updateFaq(faqId: number, payload: any): Observable<any> {
      return this.http.put(this.url + `faq/update/${faqId}`, payload);
    }
    

    addGroups(body) {
      return this.http.post(this.apiUrl + 'fleet/add-groups',body)
    }
    updateGroups(body,gId) {
      return this.http.put(this.apiUrl + `fleet/update-group/${gId}`,{name:body?.groups[0].name})
    }

    removeGroup(groupId) {
      return this.http.delete(this.apiUrl + `fleet/delete-sub-group/${groupId}`)
    }

    getGroups() {
      return this.http.get(this.apiUrl + 'fleet/group-hierarchy')
    }

    assignVIN(body) {
      return this.http.post(this.apiUrl + 'fleet/assign-vin-to-groups',body)
    }

    getgroupVINLists(consumer: string, fleetId: string,group?) {
      let apiUrl = this.authUrl + `vindetails/by-fleet-group`;
  
      // Add consumer if it's not 'All'
      if (consumer && consumer !== 'All') {
        apiUrl += `?consumer=${consumer}`;
      }
  
      // Add fleetId if provided
      if (fleetId) {
        apiUrl += `&fleetId=${fleetId}`;
      }

      // if(group) {
      //   apiUrl += `&groupId=${group}`;
      // }
  
      return this.http.get(apiUrl);
    }



    //here calling for saving category and subcategory 
    addCategory(body:string){
      return this.http.post<any>(`${this.url}category`, body);
    }
    getAllCategory() {
      return this.http.get<any>(`${this.url}category`);
    }

    // updateCategory(body: any) {
    //   return this.http.put<any>(`${this.url}category/update/category`, body);
    // }
    updateCategory(categoryId: string, body: any) {
      return this.http.put<any>(`${this.url}category/update/category/${categoryId}`, body);
    }
    
    deleteCategory(id: any): Observable<string> {
      return this.http.delete<any>(`${this.url}category/delete/${id}`, { responseType: 'text' as 'json' });
    }
    
    

    addSubCategory(body: any) {
      return this.http.post<any>(`${this.url}sub-categories`, body);
    }
    getAllSubCategory(){
      return this.http.get<any>(`${this.url}sub-categories`);
    }

    updateSubCategory(id: string, body: any) {
      return this.http.put<any>(`${this.url}sub-categories/update/sub-category/${id}`, body);
    }    

deleteSubCategory(id: string) :Observable<string>{
  return this.http.delete<any>(`${this.url}sub-categories/delete/${id}`,{ responseType: 'text' as 'json' });
}

getSubListById(id: string) {
  return this.http.get<any>(`${this.url}sub-categories/${id}/subcategories`);
}

getFaqByIds(categoryId?: any, subCategoryId?: any) {
  let params = new HttpParams();
  if(categoryId) {
    params = params.append('categoryId', categoryId)
  }
  if(subCategoryId) {
    params = params.append('subCategoryId', subCategoryId);
  }

  return this.http.get<any>(`${this.url}faq/faq-questions`, { params });
}
updateNotificationAlerts(id: number, body: any): Observable<any> {
  const endpoint = `${this.url}cms/fleet/setting`;
  const params = new HttpParams().set('fleetId', id); 
  return this.http.put<any>(endpoint, body, { params });
}

updateNotification(body: any): Observable<any> {
  const endpoint = `${this.apiUrl}fleet/event/setting`;
  return this.http.put<any>(endpoint, body);
}

getGroupList(groupId) {
  return this.http.get(this.url + `fleets/organization-sub-group/${groupId}`)
}

addUser(body) {
  return this.http.post(this.apiUrl + `user/create-user`,body)
}
getUser() {
  return this.http.get(this.apiUrl + `user/all-users`)
}

deleteUserData(emailId) {
  return this.http.delete(this.url + `account/user/${emailId}`)
}

editUserData(body,emailId) {
  let param = new HttpParams().set('emailId',emailId)
  return this.http.put(this.apiUrl + 'user/update-name',body,{params:param})
}

getAudit(vin){
    return this.http.get<any>(`${this.url}audit-view/${vin}`);
}

// Get Access token (sajal)
getAccessToken(clientId: string, clientSecret: string): Observable<any> {
  const credentials = `${clientId}:${clientSecret}`;
  const encodedCredentials = btoa(unescape(encodeURIComponent(credentials)));

  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': `Basic ${encodedCredentials}`,
    'X-Skip-Auth': 'true' // 👈 custom header to tell the interceptor to skip
  });

  const body = 'grant_type=client_credentials';

  return this.http.post(
    'https://denali.cerebrumx.ai/d1/api/v4/oauth2/token',
    body,
    { headers }
  );
}

// can json api 
callRemoteAPI(payload: any, accessToken: string): Observable<any> {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
    'X-Skip-Auth': 'true' // 👈 custom header to tell the interceptor to skip
  });

  const url = 'https://prod-remote.cerebrumx.ai/api/remote/v1/canonicalize-json';
  return this.http.post(url, payload, { headers });
}

generateXSignature(payload: any, accessToken: string, privateKey: string, time: string): Observable<any> {
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${accessToken}`,
    'privateKey': privateKey,
    'time': time, // ✅ use passed timestamp here
    'Content-Type': 'application/json',
    'X-Skip-Auth': 'true'
  });

  const url = 'https://prod-remote.cerebrumx.ai/api/remote/v1/generate-x-signature';
  return this.http.post(url, payload, { headers });
}


executeGMCommand(
  commandType: string,
  payload: any,
  accessToken: string,
  xSignature: string,
  timestamp: string
): Observable<any> {
  const url = `https://prod-remote.cerebrumx.ai/api/remote/v1/fleet/vehicles/commands/${commandType}`;

  const headers = new HttpHeaders({
    'Authorization': `Bearer ${accessToken}`,
    'X-Signature': xSignature,
    'timestamp': timestamp,
    'Content-Type': 'application/json',
    'X-Skip-Auth': 'true'
  });

  return this.http.post(url, payload, { headers });
}

getClientSecretKey() {
  return this.http.get(`https://prod-remote.cerebrumx.ai/api/remote/v1/fetch-app-token`)
}

registerCertificate(publicKey: string): Observable<any> {
  const payload = {
    publicKey: publicKey.trim()
  };
  return this.http.post(`https://prod-remote.cerebrumx.ai/api/v1/register-certificate`, payload);
}

checkRequestStatus(requestId: string): Observable<any> {
  return this.http.get(`https://prod-remote.cerebrumx.ai/api/remote/v1/fleet/vehicles/requests/${requestId}`);
}

getPublickeyUser(){
  return this.http.get(`https://prod-remote.cerebrumx.ai/api/remote/v1/public-key-registered`);
}

getLocation(vin) {
  return this.http.get(this.url+`location/${vin}`)
}

subscribeLocation(vin) {
  return this.http.post(this.url+`location/${vin}/enable-package`,{})
}

eligibilityCheck(vin){
  return this.http.get(this.apiUrlV3 + `eligibility/${vin}`)
}

getDataByFleetId(id,gid?) {
     let param = new HttpParams()
    if(gid) {
      param = param.append('groupId',gid)
    }
  let apiUrl = this.apiUrl + `fleet/${id}`;    

  return this.http.get(apiUrl,{params:param});
}

reasonListPlan() {
  return this.http.get(this.url + 'deletion-reason/reasons')
}
  realVin: string | null = null;
  realOem: string | null = null;
  fleetId: string | null = null;

 addJiraSupport(formData: FormData) {
  return this.http.post(this.url +
    'supports',
    formData
  );
}

  getGroupsById(id) {
  let param = new HttpParams().set('fleetId',id)
  return this.http.get(this.apiUrl + 'fleet/group-hierarchy',{params:param})
}

  uploadConsent(id,providerName,file) {
    let formData = new FormData()
    formData.append('providerName',providerName)
    formData.append('file',file)
    return this.http.put(this.url +`fleets/upload/consent/${id}`,formData)
  }

  addComment(vinList) {
    return this.http.post(this.url + 'manage-vehicle/comment',vinList,{responseType:'text'})
  }

  getTicket() {
    return this.http.get(this.url + 'jira/tickets')
  }

  mapVIN(body) {
    return this.http.post(this.url + 'map/vin',body)
  }
  // downtime service logs
    getHealthStatus(): Observable<any> {
    return this.http.get(`${this.url}admin/health-status/status`);
  }
  getProviderReports() {
  return this.http.get<any[]>(`${this.url}admin/health-status/provider-reports`);
}

  getConsumerExchange(consumerName:any) {
  return this.http.get<any[]>(`${this.url}admin/health-status/consumer-reports/grouped?consumer=${consumerName}`);
}

  getKafkaLagReports(startDate: string, endDate: string): Observable<any> {
    let params = new HttpParams();
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    return this.http.get(`${this.url}admin/health-status/kafka/lag-reports`, { params });
  }

  // Threshold Profile APIs
  createThresholdProfile(data: any): Observable<any> {
    return this.http.post(`${this.url}threshold-profiles`, data);
  }

  getThresholdProfiles(): Observable<any> {
    return this.http.get(`${this.url}threshold-profiles`);
  }

  updateThresholdProfile(id: any, data: any): Observable<any> {
    return this.http.put(`${this.url}threshold-profiles/${id}`, data);
  }

  deleteThresholdProfile(id: any): Observable<any> {
    const params = new HttpParams().set('id', id);
    return this.http.delete(`${this.url}threshold-profile`, { params });
  }

  assignThresholdProfile(data: { vins: string[]; thresholdProfileId: number }): Observable<any> {
    return this.http.put(`${this.url}vehicles/threshold-profile`, data);
  }

  unassignThresholdProfile(data: { vin?: string; vins?: string[] }): Observable<any> {
    const vins = data.vins ? data.vins : (data.vin ? [data.vin] : []);
    return this.http.delete(`${this.url}vehicles/threshold-profile`, {
      body: { vins }
    });
  }

  bulkUnassignThresholdProfile(data: { vins: string[] }): Observable<any> {
    return this.http.delete(`${this.url}vehicles/threshold-profile`, {
      body: data
    });
  }
}
